// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"efe49c0e","98":"a2c3e760","226":"d47e4b9e","259":"96056f15","264":"6608c421","293":"370a949a","327":"f2470638","485":"d34ef064","570":"64b178d1","582":"43baf040","636":"fd84a4de","657":"587bf838","957":"59ac490d","976":"7b9ca0ee","985":"0da70be3"}[chunkId] + ".js";
};